
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fotobox-finder",
      function () {
        return require("private-next-pages/fotobox-finder.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fotobox-finder"])
      });
    }
  